export default {
  label: 'Tipo de componente',
  items: {
    line: 'Linha',
    stackedLine: 'Linhas empilhadas',
    column: 'Coluna',
    stackedColumn: 'Colunas empilhadas',
    bar: 'Barras',
    stackedBar: 'Barras empilhadas',
    donut: 'Rosca',
    number: 'Numero',
  },
};
